import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.065 22.258a9.8 9.8 0 0 0 3.498.244l3.44-.386a1.35 1.35 0 0 0 1.19-1.49 1.35 1.35 0 0 0-1.49-1.188l1.34-.15a1.35 1.35 0 0 0 1.188-1.49 1.35 1.35 0 0 0-1.49-1.188l1.34-.15a1.35 1.35 0 0 0 1.188-1.49 1.35 1.35 0 0 0-1.49-1.188 1.35 1.35 0 0 0 1.19-1.49 1.35 1.35 0 0 0-1.49-1.188l-4.016.45-.451-4.016a2.703 2.703 0 0 0-2.979-2.377 8.9 8.9 0 0 1-2.375 7.1l-.896.954a1.9 1.9 0 0 1-1.156.577l-2.704.304M16.78 13.782l-2.678.3M15.742 16.61l-1.34.15"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M19.163 1.414c.813.813.373 2.57-.981 3.925s-3.112 1.754-3.925.941c-.813-.812-.373-2.53.981-3.885s3.112-1.793 3.925-.98M20.04 9.777c.807 0 1.576-.323 2.105-.846a2.866 2.866 0 0 0 0-4.087M16.093 8.79h.792c1.421 0 2.72-.99 3.355-2.557"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const FinancialCoach02Icon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
